import styled from 'styled-components';
import { size } from '../../../styled-components/layout/helpers';

export const Wrapper = styled.header`
  --_header-padding-inline: ${size(2)};
  --_header-padding-block: ${size(1.25)};

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--_header-padding-inline);
  padding: var(--_header-padding-block) var(--_header-padding-inline);
  background-color: var(--c-mainnav-bg);

  ${(props) => props.theme.breakpoint.LtMd} {
    flex-direction: column;
    align-items: start;
    gap: var(--_header-padding-block);
  }
`;

export const Utilities = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1.5)};

  ${(props) => props.theme.breakpoint.LtMd} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const MobileMenu = styled.div`
  ${(props) => props.theme.breakpoint.Md} {
    display: none;
  }
`;

export const ExternalUiLabel = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: ${(props) => props.theme.font.size.small};
`;

export const ScopeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1)};
`;

export const BetaBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: ${size(0.25)} ${size(0.75)};
  background-color: #2563eb;
  color: #ffffff;
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: var(--font-weight-bold);
  border-radius: ${size(0.5)};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;
